import { makeStyles } from '@mui/styles';
import React, { useCallback } from 'react';
import ReactResizeDetector from 'react-resize-detector';

import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';
import { ENTITY_DISPLAY_LEFT_RIGHT_PADDING } from '../../form-designer/constants/runtime.constants';

const useStyles = makeStyles({
  root: {
    height: 'calc(100vh - 64px)',
    width: '100%',
    backgroundColor: ({ isMobileDevice }) => (isMobileDevice ? '#fff' : 'inherit'),
    padding: ({ isMobileDevice }) =>
      isMobileDevice ? 0 : `0 ${ENTITY_DISPLAY_LEFT_RIGHT_PADDING}px 10px`,
  },
});

const PageWrapper = ({ children, onHeightChange }) => {
  const { isMobileDevice } = useWindowDimensions();
  const classes = useStyles({ isMobileDevice });

  const onResize = useCallback(
    (_, h) => {
      onHeightChange(h);
    },
    [onHeightChange]
  );

  return (
    <>
      <div className={classes.root}>{children}</div>
      <ReactResizeDetector handleHeight onResize={onResize} />
    </>
  );
};

export default PageWrapper;
